/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  // {
  //   url: "/apps/email",
  //   name: "Email",
  //   slug: "email",
  //   icon: "MailIcon",
  //   i18n: "Email",
  // },
  {
    header: '銷售工具',
    icon: 'PackageIcon',
    i18n: '銷售工具',
    items: [
      {
        url: '/apps/meal-coupon',
        name: '餐卷銷售',
        slug: '餐卷銷售',
        icon: 'ArchiveIcon',
        i18n: '餐卷銷售'
      }
      // {
      //   url: '/apps/year-meal',
      //   name: '年菜銷售',
      //   slug: '年菜銷售',
      //   icon: 'ShoppingCartIcon',
      //   i18n: '年菜銷售'
      // }
    ]
  },
  {
    header: '數據',
    icon: 'PieChartIcon',
    i18n: '數據',
    items: [
      {
        url: '/apps/meal-coupon-table',
        name: '餐卷銷售總覽',
        slug: '餐卷銷售總覽',
        icon: 'PieChartIcon',
        i18n: '餐卷銷售總覽'
      }
      // {
      //   url: '/apps/year-meal',
      //   name: '年菜銷售',
      //   slug: '年菜銷售',
      //   icon: 'ShoppingCartIcon',
      //   i18n: '年菜銷售'
      // }
    ]
  },
  {
    // header: '設定',
    // icon: 'LayersIcon',
    // i18n: '設定',
    // items: [
    // {
    //   url: '/apps/setting-meal-coupon',
    //   name: '設定餐卷',
    //   slug: '設定餐卷',
    //   icon: 'SettingsIcon',
    //   i18n: '設定餐卷'
    // }
    // {
    //   url: '/apps/setting-year-meal',
    //   name: '設定年菜',
    //   slug: '設定年菜',
    //   icon: 'SettingsIcon',
    //   i18n: '設定年菜'
    // },
    // {
    //   url: '/apps/setting-user',
    //   name: '權限設定',
    //   slug: '權限設定',
    //   icon: 'SettingsIcon',
    //   i18n: '權限設定'
    // }
    // ]
  }
]
